import {node_observable_component} from 'common/util/ComponentDecorator';

@node_observable_component
export default class PaymentMethodsPopup {
	static classname = 'payment-methods-popup';

	constructor() {
		this.bindEvents();
	}

	bindEvents = () => {
		$('.product-cart__payment-method').on('click', (e, args) => {
			$('.payment-methods-popup').addClass('payment-methods-popup_opened');
		});
		$(document).mouseup(function (e) {
			var popup = $(".payment-methods-popup__container");
			if (!$('.popup').is(e.target) && !popup.is(e.target) &&   popup.has(e.target).length === 0) {
				$('.payment-methods-popup').removeClass('payment-methods-popup_opened');
			}
		});
		$('.payment-methods-popup__close').on('click', () => {
			$('.payment-methods-popup').removeClass('payment-methods-popup_opened');
		});
		$(document).keyup(function(e) {
			if (e.key === "Escape") {
				$('.payment-methods-popup').removeClass('payment-methods-popup_opened');
			}
		});

		$('.toggler__btn1').on('click', () => {
			$('.toggler').removeClass('toggler_st1 toggler_st2 toggler_st3').addClass('toggler_st1');
			$('.toggler').trigger('change_value', {val: 0});
		});
		$('.toggler__btn2').on('click', () => {
			$('.toggler').removeClass('toggler_st1 toggler_st2 toggler_st3').addClass('toggler_st2');
			$('.toggler').trigger('change_value', {val: 1});
		});
		$('.toggler__btn3').on('click', () => {
			$('.toggler').removeClass('toggler_st1 toggler_st2 toggler_st3').addClass('toggler_st3');
			$('.toggler').trigger('change_value', {val: 2});
		});
	};
};
